<template lang="pug">
.confirm-container(@touchmove.prevent)
  popup(@close='close')
    .confirm-content
      .title(:class=`{
          'is-subtitle': !!info.subtitle,
        }`)
        .card-wrapper
          CardC(:info='info', :mode='3')
      .description
        p.titles 仅限哈啰APP骑行使用：
        p.content 本卡为哈啰APP专享卡，购卡后仅限在哈啰APP使用
      template(v-if='info')
        .description(v-if='info.businessType === 1')
          p.titles 本卡适用于单车骑行，不适用于助力车骑行：
          p.content 本卡限购卡城市使用，景区及特别特别使用范围区域除外
        .description(v-if='info.businessType === 2')
          p.titles 仅限助力车骑行，不适用单车骑行
          p.content 本卡限哈啰助力车使用，限城市共享、有桩业务，限购卡城市使用，抵扣金额以卡面信息为准
      .description
        p.titles 温馨提示：
        p.content 本卡仅限哈啰APP开锁可用，支付宝扫码骑车仍需按此付费
    .footer
      .price
        span.current {{ info.finalPrice }}
        span.unit 元
        span.save 已优惠{{ (info.originPrice-info.finalPrice).toFixed(2) }}元
      .btn.actived(@click='onConfirm') 购买
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import popup from '../../components/popup';
import CardC from './card-c';

export default {
  components: {
    popup,
    CardC,
  },
  props: {
    info: {
      type: Object,
      default: () => ({
        title: '单车30天不限次卡·APP专享',
        currentPrice: '32',
        originPrice: '50',
        businessType: 1,
        save: '18',
        img: '',
        tags: [{ wordsValue: '全国可用' }, { wordsValue: 'APP专享限时补贴' }],
      }),
    },
    leftBtn: {
      type: String,
      default: '取消',
    },
    rightBtn: {
      type: String,
      default: '立即支付',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.appendToBody) {
      this.$nextTick(() => {
        document.body.appendChild(this.$el);
      });
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onConfirm() {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_newgo',
        categoryId: 'platform',
        businessInfo: {
          card_name: this.info.title,
          business: this.info.businessType,
        },
      });
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="less" scoped>
.confirm-container {
  font-size: 16px;

  .confirm-content {
    position: relative;
    padding-top: 0.65rem;
    padding-left: 0.25rem;
    padding-right: 0.27rem;
    padding-bottom: 0.01rem;
    width: 100vw;
    box-sizing: border-box;
    background-color: #f7f9fa;
    height: 2.53rem;
    border-radius: 0.16rem 0.16rem 0 0;

    .card-wrapper {
      padding: 0.12rem;
      width: 3.51rem;
      height: 0.96rem;
      background: #fff;
      box-shadow: 0 0.04rem 0.08rem 0 rgba(188, 196, 204, 0.1);
      border-radius: 0.08rem;
    }

    .title {
      color: #242729;
      font-size: 0.2rem;
      font-weight: 500;
      padding: 0.02rem 0 0 0;
      text-align: left;
      position: absolute;
      top: -0.55rem;
      left: 50%;
      transform: translateX(-50%);
    }

    .is-subtitle {
      top: -0.71rem;

      .card-container {
        padding-top: 0.17rem;
      }
    }

    .description {
      text-align: left;

      .titles {
        font-size: 0.12rem;
        font-weight: 500;
        color: #242729;
        line-height: 0.17rem;
      }

      .content {
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;
        line-height: 0.17rem;
        margin-top: 0.03rem;
        margin-bottom: 0.23rem;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.12rem;
    padding: 0 0.12rem;

    .price {
      font-size: 0.12rem;
      height: 0.35rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.17rem;

      .current {
        font-size: 0.3rem;
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-weight: bold;
      }

      .unit {
        margin-left: 0.02rem;
        margin-right: 0.04rem;
      }

      .save {
        color: #ff5526;
      }
    }

    .btn {
      width: 1.58rem;
      height: 0.48rem;
      background: #f0f3f5;
      border-radius: 0.08rem;
      font-size: 0.17rem;
      font-weight: 500;
      color: #879099;
      line-height: 0.48rem;

      &.actived {
        width: 1.41rem;
        height: 0.48rem;
        background: #08f;
        border-radius: 0.08rem;
        font-size: 0.17rem;
        font-weight: 500;
        color: #fff;
        line-height: 0.48rem;
      }
    }
  }
}
</style>
